import { Redirect, Slot } from 'expo-router'
import { useEffect, type ReactNode } from 'react'

import { getIsLoggedIn } from '@/src/features/auth/utils/getIsLoggedIn'
import { useCommunityJoinSearchParams } from '@/src/features/community/ui/hooks/useCommunityJoinSearchParams'
import { GTM } from '@/src/general/utils/gtm'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import { parseIdDash } from '@/src/general/utils/parseIdDash'
import { useRoutes } from '@/src/general/utils/routes'

const CommunityJoinLayout = (): ReactNode => {
  const { idSlug, course, origin, source } = useCommunityJoinSearchParams()
  const isLoggedIn = getIsLoggedIn()
  const { routes } = useRoutes()

  const [id, slug] = idSlug ? parseIdDash(idSlug) : []

  useEffect(() => {
    if (id && source !== TRACKING_SOURCE.COMMUNITY_JOIN) {
      GTM.sendEvent({ trackingSource: source, communityInfos: { community_id: id } })
    }
  }, [id, source])

  if (!id || !slug) return <Redirect href={routes.communities()} />

  if (!isLoggedIn) return <Redirect href={routes.communityLanding({ id, slug, course, origin, source })} />

  return <Slot />
}

export default CommunityJoinLayout
